import React from "react";
import { GoDotFill } from "react-icons/go";
import { IoClose } from "react-icons/io5";
import { MdDone } from "react-icons/md";


const StatusChip = ({ status }) => {
  return (
    <>
      {status === "in-stock" && (
        <div className="px-4 py-1 text-[#027A48] rounded-full items-center flex gap-x-1 bg-[#ECFDF3] w-fit">
          <MdDone />
          <span className="font-bold text-[10px]">In-Stock</span>
        </div>
      )}
      {status === "sold-out" && (
        <div className="px-4 py-1 text-[#DC2626] rounded-full items-center flex gap-x-1 bg-[#FEF3F2] w-fit">
         <IoClose />
          <span className="font-bold text-[10px]">Sold Out</span>
        </div>
      )}
      {status === "low-stock" && (
        <div className="px-4 py-1 text-[#FF8D28] rounded-full items-center flex gap-x-1 bg-[#FFF6ED] w-fit">
      <GoDotFill />
          <span className="font-bold text-[10px]">Low Stock</span>
        </div>
      )}
    </>
  );
};

export default StatusChip;
